import { render, staticRenderFns } from "./IndexTalentoHumano.vue?vue&type=template&id=7669cd51&scoped=true"
import script from "./IndexTalentoHumano.vue?vue&type=script&lang=js"
export * from "./IndexTalentoHumano.vue?vue&type=script&lang=js"
import style0 from "./IndexTalentoHumano.vue?vue&type=style&index=0&id=7669cd51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7669cd51",
  null
  
)

export default component.exports